import { render, staticRenderFns } from "./labor.vue?vue&type=template&id=50f6079b&"
import script from "./labor.vue?vue&type=script&lang=js&"
export * from "./labor.vue?vue&type=script&lang=js&"
import style0 from "./labor.vue?vue&type=style&index=0&id=50f6079b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports